import { useTextDomainContext } from "@/app/providers";
import React, { useContext } from "react";
import { ModalBox } from "./ModalBox";
import { Button, Grid, TextField, Tooltip, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { bool, func } from "prop-types";
import { enqueueSnackbar } from "notistack";
import {
  useDeletePublicToken,
  useGeneratePublicToken,
  useGetPublicToken,
} from "@/hooks";

type ApiKeyModalProps = {
  open: boolean;
  handleClose: () => void;
};

export const ApiKeyModal = (props: ApiKeyModalProps) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  const loading = false;
  const readOnly = true;

  const { generatePublicToken, loading: loadingGenerate } =
    useGeneratePublicToken(
      () => {
        // Token will be handled by the hook itself
      },
      (error) => {
        enqueueSnackbar(error?.message, {
          variant: "error",
        });
      },
    );

  const { token } = useGetPublicToken();

  // Use token directly instead of state
  const apiKey = token || "";

  const { delete: deletePublicToken, deleting } = useDeletePublicToken();

  //#region Handlers
  const onClickToken = () => {
    navigator.clipboard.writeText(apiKey).then(() => {
      enqueueSnackbar(gettext("Copied to clipboard"), {
        variant: "info",
      });
    });
  };

  const handleGenerateToken = () => {
    generatePublicToken();
  };
  const handleDeleteToken = () => {
    deletePublicToken();
    // No need to setApiKey since we're using token directly
  };
  //#endregion Handlers

  return (
    <ModalBox open={props.open} handleClose={props.handleClose}>
      <Box
        sx={{
          backgroundColor: (theme) => theme.palette.grey[50],
          p: 4,
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            pb: 3,
          }}
        >
          <Typography variant="h4">{gettext("API Key")}</Typography>
        </Box>
        <Box>
          <Stack
            spacing={2}
            sx={{
              height: "100%",
            }}
          >
            <Grid size={{ xs: 12 }}>
              <Tooltip title={gettext("Click to copy")}>
                <TextField
                  placeholder={gettext("API key")}
                  multiline
                  // disabled
                  // rows={2}
                  // minRows={4}
                  fullWidth
                  value={apiKey}
                  onClick={onClickToken}
                  slotProps={{
                    input: {
                      readOnly: Boolean(readOnly),
                      // disabled: Boolean(readOnly),
                    },
                  }}
                />
              </Tooltip>
            </Grid>
            <Grid size={{ xs: 12 }} sx={{ textAlign: "center" }}>
              {!apiKey && (
                <Button
                  variant="contained"
                  loading={loadingGenerate}
                  fullWidth
                  onClick={handleGenerateToken}
                  // disabled={saveButtonDisabled}
                >
                  {gettext("Generate API Key")}
                </Button>
              )}
              {apiKey && (
                <Button
                  variant="contained"
                  loading={loading}
                  fullWidth
                  onClick={handleDeleteToken}
                  disabled={deleting}
                  sx={{ color: "error" }}
                >
                  {gettext("Delete API Key")}
                </Button>
              )}
            </Grid>
          </Stack>
          {/*<ChangePasswordForm handleClose={props.handleClose}/>*/}
        </Box>
      </Box>
    </ModalBox>
  );
};

ApiKeyModal.propTypes = {
  open: bool.isRequired,
  handleClose: func.isRequired,
};
